import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from '@/features/auth/AuthProvider'
import ProtectedRoute from '@/components/shared/ProtectedRoute'
import Layout from '@/components/shared/Layout'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'
import LoginPage from '@/features/auth/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import ProductosPage from '@/features/productos/ProductosPage'
import StockPage from '@/features/stock/StockPage'
import CategoriasPage from '@/features/categorias/CategoriasPage'
import DepositosPage from '@/features/depositos/DepositosPage'
import HistorialVentasPage from '@/features/ventas/HistorialVentasPage'
import CajaPage from '@/features/caja/CajaPage'
import ComprasPage from '@/features/compras/ComprasPage'
import RetirosPage from '@/features/retiros/RetirosPage'
import ClientesPage from '@/features/clientes/ClientesPage'
import CuentaCorrientePage from '@/features/clientes/CuentaCorrientePage'
import ReportesPage from '@/features/reportes/ReportesPage'
import AsistentePage from '@/features/asistente/AsistentePage'
import ConfiguracionPage from '@/features/configuracion/ConfiguracionPage'
import UsuariosPage from '@/features/usuarios/UsuariosPage'
import EmpleadosPage from '@/features/admin/EmpleadosPage'
import RolesPage from '@/features/admin/RolesPage'
import MovimientosPage from '@/features/admin/MovimientosPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
})

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />

              <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                  <Route index element={<DashboardPage />} />
                  <Route path="/ventas" element={<Navigate to="/caja" replace />} />
                  <Route path="/ventas/historial" element={<HistorialVentasPage />} />
                  <Route path="/caja" element={<CajaPage />} />
                  <Route path="/productos" element={<ProductosPage />} />
                  <Route path="/stock" element={<StockPage />} />
                  <Route path="/compras" element={<ComprasPage />} />
                  <Route path="/retiros" element={<RetirosPage />} />
                  <Route path="/clientes" element={<ClientesPage />} />
                  <Route path="/clientes/deudas" element={<CuentaCorrientePage />} />
                  <Route path="/reportes" element={<ReportesPage />} />
                  <Route path="/asistente" element={<AsistentePage />} />

                  <Route element={<ProtectedRoute requiredNivel={1} />}>
                    <Route path="/admin/empleados" element={<EmpleadosPage />} />
                    <Route path="/admin/roles" element={<RolesPage />} />
                    <Route path="/admin/movimientos" element={<MovimientosPage />} />
                    <Route path="/categorias" element={<CategoriasPage />} />
                    <Route path="/depositos" element={<DepositosPage />} />
                    <Route path="/configuracion" element={<ConfiguracionPage />} />
                    <Route path="/usuarios" element={<UsuariosPage />} />
                  </Route>
                </Route>
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            <Toaster
              position="top-right"
              toastOptions={{
                style: {
                  fontFamily: 'var(--me-sans)',
                  fontSize: 13.5,
                  background: 'var(--me-surface)',
                  color: 'var(--me-text)',
                  border: '1px solid var(--me-line-2)',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
                  borderRadius: 12,
                  padding: '10px 14px',
                },
              }}
            />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
